import { useLightBox } from "../contexts/lightBoxContext/lightBoxContext.js";
import { useMail } from "../contexts/mailContext/mailContext.js";

//INBOX+MAILDATA

export const useCloseLightBox = () => {
  const { resetPageNumber, resetFilesList } = useMail();
  const { closeLightBox } = useLightBox();

  const func = () => {
    if (window.location.href.includes("/inbox")) {
      resetPageNumber();
      resetFilesList();
    }
    closeLightBox();
  };
  return func;
};
